var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 125,
    viewBox: "0 0 326 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.312 1.64144C285.793 48.4161 235.315 83.8744 178.249 104.244C121.182 124.613 59.6604 129.132 0.229793 117.32",
    stroke: "white",
    strokeWidth: 1.08648,
    strokeDasharray: "8.69 8.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot4);
export default __webpack_public_path__ + "static/media/dot4.2fe3e55b9c6342c12c1eb8945b4015e2.svg";
export { ForwardRef as ReactComponent };